import s from "./Account.module.scss";
import Notification from "./local components/Notification";
import TabsTemplate from "../../../../global components/TabsTemplate/TabsTemplte";
import Header from "./local components/Header/Header";
import Profile from "./local components/Profile";
import PasswordSettings from "./local components/PasswordSettings";

function Account() {
  

  const accountTabs = [
    {
      key: "1",
      label: (
        <>
          <h2>Profile</h2>
        </>
      ),
      children: <Profile />,
    },
    {
      key: "2",
      label: (
        <>
          <h2>Password Settings</h2>
        </>
      ),
      children: <PasswordSettings />,
    },
    // {
    //   key: "3",
    //   label: (
    //     <>
    //       <h2>Notification</h2>
    //     </>
    //   ),
    //   children: <Notification />,
    // },
  ];

  return (
    <div className={s.wrapper}>
      <Header />
      <TabsTemplate
        tabItems={accountTabs}
        wrapperClassname={s.customClass}
        // Pass the tab change handler
        withBorderBottom={true}
      />
    </div>
  );
}
export default Account;
